import { AfterViewInit, Component, Renderer2, EventEmitter, ViewChild, ElementRef, OnInit } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwMessage, DwMessageSeverity, DwModalConfig, DwModalHandler, DwModalResult, DwOrmDataService, DwOrmDataServiceToken, DwSecurityUserService } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { FormGroup, FormControl } from '@angular/forms';
import { RejectedNotesModalResultModel } from '../../models/rejected-notes-modal-result-model';

@Component({
  selector: 'app-rejected-notes-modal',
  templateUrl: './rejected-notes-modal.component.html',
  styleUrls: ['./rejected-notes-modal.component.scss']
})
export class RejectedNotesModalComponent implements OnInit, DwModalHandler, AfterViewInit {
  rejectedNotes: any;
  rejectedByEthos_UserId: any;

  constructor(
    private dwSecurityUserService: DwSecurityUserService,
    private renderer: Renderer2
  ) { }

  modalConfig: DwModalConfig<any>;
  message: DwMessage;

  closeModal: EventEmitter<DwModalResult<any>>;


  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult<any>> {

    let modalResult: DwModalResult<RejectedNotesModalResultModel> = {
      cancelled: false,
      buttonCommand: buttonConfig.command,
      closeModal: true,
    };

    this.message = null;

    switch (buttonConfig.command) {
      case DwButtonCommand.saveAndClose:
        return this.rejectedNotesSave();

      case DwButtonCommand.cancel:
        modalResult.cancelled = true;
        break;
    }

    return of(modalResult);
  }

  ngOnInit(): void {
    this.rejectedNotes = this.modalConfig.data;
    this.rejectedByEthos_UserId = this.getTrustUserId();
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      var elem = this.renderer.selectRootElement('#notes');
      if (elem) elem.focus();
    }, 500);    
  }

  private getTrustUserId() {

    const user = this.dwSecurityUserService.securityContext.ApplicationUser;

    if (user) {
      const wachterUser = new WachterUserExt(user);
      return wachterUser.trustUserId;
    }

    return null;
  }

  rejectedNotesSave(): Observable<DwModalResult<RejectedNotesModalResultModel>> {

    if (!this.rejectedNotes) {
      this.message = {
        messageBody: "Rejected notes are required",
        severity: DwMessageSeverity.error
      };

      return of({
        closeModal: false,
        cancelled: true,
      });
    }

    return of({
      closeModal: true,
      cancelled: false,
      data: { rejectedNotes: this.rejectedNotes, rejectedByEthos_UserId: this.rejectedByEthos_UserId }
    });

  }

}
